import { supabase } from "./supabase";

/** Erros que não dizem nada sobre o app (rede caída, extensão do navegador, aviso do ResizeObserver). */
const IGNORAR = [/ResizeObserver loop/i, /Failed to fetch/i, /NetworkError/i, /Load failed/i, /^Script error\.?$/i, /AbortError/i];

const recentes = new Map<string, number>();

export function deveRegistrar(mensagem: string, agora = Date.now()): boolean {
  if (!mensagem.trim() || IGNORAR.some((r) => r.test(mensagem))) return false;
  const ultima = recentes.get(mensagem);
  if (ultima && agora - ultima < 30_000) return false;
  recentes.set(mensagem, agora);
  if (recentes.size > 50) recentes.delete(recentes.keys().next().value!);
  return true;
}

/**
 * Grava o erro de uma tela no banco (tabela app_erros, tela Registros do admin). Nunca lança:
 * se não der para gravar (sem internet, sem login), o erro continua só no console.
 */
export function registrarErro(erro: unknown, contexto?: Record<string, unknown>) {
  const e = erro instanceof Error ? erro : new Error(typeof erro === "string" ? erro : JSON.stringify(erro));
  const mensagem = `${e.name && e.name !== "Error" ? `${e.name}: ` : ""}${e.message}`;
  if (!deveRegistrar(mensagem)) return;
  void supabase.rpc("wms_app_erro_registrar", {
    p_mensagem: mensagem,
    p_pilha: e.stack ?? null,
    p_rota: window.location.pathname,
    p_versao: __VERSAO__,
    p_navegador: navigator.userAgent,
    p_contexto: contexto ?? null,
  }).then(() => undefined, () => undefined);
}

/** Erro fora do React (evento, promessa sem catch): também vai para o registro. */
export function instalarCapturaDeErros() {
  window.addEventListener("error", (ev) => registrarErro(ev.error ?? ev.message, { origem: "janela" }));
  window.addEventListener("unhandledrejection", (ev) => registrarErro(ev.reason, { origem: "promessa" }));
}
